import {useState, useEffect} from 'react'

const Cods = (props) => {
    const [empresa, setEmpresa] = useState('')  
    const [cod, setCod] = useState('')
    const [cant, setCant] = useState(0)
    const [modo, setModo] = useState('Agregar')
    const [codigos, setCodigos] = useState([])
    const [elegido, setElegido] = useState({id: 0})
    const [recargar, setRecargar] = useState(0)
    const [puedeBorrar, setPuedeBorrar] = useState(false)

    useEffect(() => {
    if (props.evento.con_cod) {
    const data = {
      method: 'GET',
      headers: {
        'Authorization': 'Bearer ' + props.token,
        'Content-Type': 'application/json' 
      }
    }
   fetch(props.back + 'admin/traer_codigos/tabla/' + props.evento.tabla_cods, data)
    .then (response => response.json())
    .then (json => {
        setCodigos(json)
    })
    }
  },[props.evento, recargar, props.back, props.token])

  const f_selected = 'grid grid-cols-5 gap-2 items-center text-sm bg-white text-red-600'
  const f_no = 'grid grid-cols-5 gap-2 items-center text-sm bg-white'

  const mostrar = () => {
    return codigos.map(a => {
        return (
            <div className={a.id===elegido.id ? f_selected : f_no} onClick={e => elegir(a)}>
                <label className='col-span-2 justify-self-start px-2'>{a.empresa}</label>
                <label className='justify-self-start px-2'>{a.codigo}</label>
                <label className='justify-self-end px-2'>{a.total}</label>
                <label className='justify-self-end px-2'>{a.usado}</label>
            </div>
         )
    })        
  }

    const elegir = (a) => {
       setElegido(a.id === elegido.id ? {id: 0} : a )
       setCod(a.id === elegido.id ? '' : a.codigo)
       setEmpresa(a.id === elegido.id ? '' : a.empresa)
       setCant(a.id === elegido.id ? '' : a.total)
       setModo(a.id === elegido.id ? 'Agregar' : 'Editar')
       setPuedeBorrar(parseInt(a.usado) ? false : true)
    }

    const eliminar = () => {
        const data = {
            method: 'POST',
            body: JSON.stringify({id: elegido.id, tabla: props.evento.tabla_cods}),
            headers: {
                'Authorization': 'Bearer ' + props.token,
                'Content-Type': 'application/json' 
            }
        }
        fetch(props.back + 'admin/eliminar_codigo', data)
        .then (response => response.json())
        .then (json => {
            setElegido({id:0})
            setCod('')
            setEmpresa('')
            setCant('')
            setModo('Agregar')
            setRecargar(recargar + 1)
        })
    }

     const guardar = () => {
        
        if (isNaN(cant)) {
            alert('la cantidad debe ser un número')
            return
        }
        if (!cod.length) {
            alert('Debe dar un código único')
            return
        }
        if (!elegido.id && codigos.find(a => a.codigo===cod.trim().toUpperCase())!== undefined) {
            alert('Código ya existe')
            return
        }

        const data = {
            empresa: empresa, 
            total: parseInt(cant),
            tabla: props.evento.tabla_cods,
            id: elegido.id,
            usado: ! puedeBorrar,
            tabla_e: props.evento.tabla,
            codigo: !elegido.id ? cod.toLowerCase() : elegido.codigo.toLowerCase()
        }
        const subir = {
            method: 'POST',
            headers: {
                'Authorization': 'Bearer ' + props.token,
                'Content-Type': 'application/json' 
            },
            body: JSON.stringify(data)
        }
        fetch(props.back + 'admin/guardar_codigo' , subir)
            .then (response => response.json())
            .then (json => {
                console.log(json)
                setCod('')
                setCant(0)
                setEmpresa('')
                setRecargar(recargar + 1)
                elegir({id:0})
            })
    }

    return (<>
        <div className='grid grid-cols-2 my-2 text-sm'>
            <div className='flex px-2 flex-col justify-start w-full overflow-x-hidden'>
              <div className='grid grid-cols-5 gap-2 border-b-2 border-2 border-zinc-800 items-center text-sm'>
                <label className='col-span-2 justify-self-start px-2'>Empresa</label>
                <label className='justify-self-start px-2'>Código</label>
                <label className='justify-self-end px-2'>Máximo</label>
                <label className='justify-self-end px-2'>Usados</label>
              </div>
              <div className='overflow-y-auto overflow-x-hidden h-9/10 w-full text-sm'>
                {mostrar()}
              </div>
            </div>
        
            <div className='bg-gray-300 flex flex-col justify-start text-lg px-2 w-1/2'>
                <div className='grid grid-cols-2 gap-4 my-2'>
                    <label className='w-64 my-2 px-2 text-red-600'>{modo}</label>
                <button 
                    className='bg-white text-blue-800 p-2 hover:text-white hover:bg-blue-800'
                    onClick={e => guardar()}
                >
                    Guardar
                </button>
                </div>
            <div className='grid grid-cols-2 gap-2 my-2'>
                <label className='px-2 justify-self-start'>Empresa</label>
                <input 
                    type='text'
                    className='px-2 justify-self-end w-40 bg-white outline-0'
                    value={empresa}
                    onChange={e => setEmpresa(e.target.value)}
                />
            </div>
            <div className='grid grid-cols-2 gap-2 my-2'>
                <label className='px-2 justify-self-start'>Código</label>
                <input 
                    type='text'
                    className='px-2 justify-self-end w-40 bg-white outline-0'
                    value={cod}
                    onChange={e => setCod(e.target.value)}
                />
            </div>
            <div className='grid grid-cols-2 gap-4 my-2'>
                <label className='px-2 justify-self-start'>Cantidad</label>
                <input 
                    type='text'
                    className='px-2 justify-self-end w-40 bg-white outline-0 text-end'
                    value={cant}
                    onChange={e => setCant(parseInt(e.target.value))}
                />
            </div>
            <div className='flex flex.row mx-10 justify-center mt-2'>
                <button 
                    className='w-32 p-2 text-white bg-red-400 hover:bg-red-800 rounded-xl disabled:bg-zinc-500'
                    disabled={!puedeBorrar}
                    onClick= { e => eliminar()}
                >
                    Eliminar
                </button>
            </div>
        </div>

    </div>
    </>)
}

export default Cods
